import { Container, Sprite, Texture } from 'pixi.js';

import { Shared } from '../App';
import { Panel } from './Panel';

const defaultOpts = {
    w: 250,
    h: 350,
    image: '' as string | Texture,
    imageScale: 1,
};

export type CardOpts = typeof defaultOpts;

export class Card
{
    public view: Container;
    public image: Sprite;
    public holder: Sprite;
    public panel: Panel;

    constructor(opts: Partial<CardOpts> = {})
    {
        const o = { ...defaultOpts, ...opts };

        this.view = new Container();

        this.panel = new Panel({
            w: o.w,
            h: o.h,
        });
        this.view.addChild(this.panel.view);

        this.holder = new Sprite(Shared.assets.getTexture('item-holder-large'));
        this.holder.anchor.set(0.5);
        this.holder.scale.set(1.5);
        this.view.addChild(this.holder);

        this.image = new Sprite();
        this.image.anchor.set(0.5);
        this.view.addChild(this.image);

        this.refresh(o);
    }

    public setImage(img: string | Texture): void
    {
        if (!img)
        {
            this.image.visible = false;

            return;
        }
        this.image.visible = true;
        if (typeof img === 'string')
        {
            this.image.texture = Shared.assets.getTexture(img);
        }
        else
        {
            this.image.texture = img;
        }
    }

    public refresh(opts: Partial<CardOpts>): void
    {
        if (opts?.image) this.setImage(opts.image);
        if (opts?.imageScale) this.image.scale.set(opts.imageScale);
    }
}
